module.exports = {"532504001":"弥阳街道","532504102":"新哨镇","532504103":"虹溪镇","532504104":"竹园镇","532504105":"朋普镇","532504106":"巡检司镇","532504107":"西一镇","532504108":"西二镇","532504109":"西三镇","532504110":"东山镇","532504202":"五山乡","532504203":"江边乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532504.json
// module id = 2763
// module chunks = 0